import { useRouteLoaderData } from '@remix-run/react';
import type { BuildHubRootData } from '~/routes/_app._pm.app.project.$id';
const BUILD_HUB_ROOT_ROUTE = 'routes/_app._pm.app.project.$id';

/**
 * useBuildHubData is a hook that returns the build hub root data.
 * It is used to get the build hub root data from the route loader data to avoid fetching the data again.
 *
 * @returns The build hub root data.
 */
export const useBuildHubData = (): BuildHubRootData => {
    return useRouteLoaderData(BUILD_HUB_ROOT_ROUTE) as BuildHubRootData;
};
